var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartHalf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255.821 112.168C255.815 101.787 251.774 91.832 244.55 84.375L236.362 75.924C208.669 47.34 170.813 32 133.314 32C103.166 32 73.243 41.926 49.049 62.861C-13.106 116.653 -16.2 212.516 39.831 270.485L233.015 470.196C233.078 470.262 233.142 470.327 233.206 470.392C241.494 478.824 256.005 472.126 256 460.304C255.971 393.113 255.854 173.691 255.821 112.168ZM208.036 375.329L74.353 237.129C42.105 203.766 34.465 138.971 80.469 99.154C120.38 64.615 175.077 81.658 201.877 109.321C204.422 111.947 206.169 113.75 208.036 115.678V375.329Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartHalf);
export default __webpack_public_path__ + "static/media/heart-half.92fe71750cbf998f4913d2aa26d820dc.svg";
export { ForwardRef as ReactComponent };